import * as React from 'react';

import { useRender } from '@base-ui/react/use-render';

type ActionTriggerProps = useRender.ComponentProps<'button'> & {
    render: NonNullable<useRender.ComponentProps<'button'>['render']>;
};

export const ActionTrigger = React.forwardRef<HTMLButtonElement, ActionTriggerProps>(
    ({ render, ...props }, ref) =>
        useRender({
            defaultTagName: 'button',
            ref,
            props: {
                'data-slot': 'action-trigger',
                ...props,
            },
            render,
        }),
);

ActionTrigger.displayName = 'ActionTrigger';
